const xArr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
const numArr = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
let allabcArr = xArr.join('').toUpperCase().split('').concat(xArr).concat(numArr);

export const getRandomStr = function(len = 8) {
	let restr = '';
	while(restr.length < len) {
		let index = Math.floor(Math.random() * allabcArr.length);
		let str = allabcArr[index];
		restr +=  str;
	};
	return restr;
}